import { z } from "zod";

// Registration form schema for the RegisterSchoolForm component
export const registerFormSchema = z.object({
  name: z
    .string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name is too long")
    .regex(/^[a-zA-Z\s]+$/, "Name should only contain letters and spaces"),

  email: z
    .email("Please enter a valid email address")
    .min(5, "Email is too short")
    .max(100, "Email is too long"),

  invitationCode: z
    .string()
    .min(5, "Invitation code must be at least 5 characters")
    .max(20, "Invitation code is too long")
    .regex(
      /^[A-Z0-9]+$/,
      "Invitation code should only contain uppercase letters and numbers"
    ),

  phoneNumber: z
    .string()
    .min(10, "Phone number must be exactly 10 digits")
    .max(10, "Phone number must be exactly 10 digits")
    .regex(/^\d{10}$/, "Phone number should only contain 10 digits"),

  otp: z
    .string()
    .optional()
    .refine((val) => !val || (val.length === 4 && /^\d{4}$/.test(val)), {
      message: "OTP must be exactly 4 digits",
    }),

  acceptTerms: z.boolean().refine((val) => val === true, {
    message: "You must accept the terms and conditions",
  }),
});

export type RegisterFormData = z.infer<typeof registerFormSchema>;

// Validation helper functions
export const validateRegisterFormData = (data: unknown) => {
  return registerFormSchema.safeParse(data);
};

// Form states
export type FormState = "initial" | "otp-sent" | "otp-error" | "success";
